'use client';

// styled-components
import { css } from 'styled-components';

// typography
export type FontFamily = 'Lora' | 'Work Sans';
export type Weight =
  | 'thin'
  | 'extralight'
  | 'light'
  | 'regular'
  | 'medium'
  | 'semibold'
  | 'bold'
  | 'extrabold'
  | 'black';

export type WeightedFont = {
  [key in Weight]?: any;
};

export type FontWeights = {
  [key in Weight]?: number;
};

export const generateFont = (
  fontFamily: FontFamily,
  fontSize: number,
  lineHeight: number,
  fontWeight: number,
) => css`
  ${fontWeight} ${fontSize}px/${lineHeight} '${fontFamily}', sans-serif
`;

const weights = {
  thin: 100,
  extralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};
export const generateWeightedFont = (
  fontFamily: FontFamily,
  fontSize: number,
  lineHeight: number,
): WeightedFont => {
  let weightedFont: WeightedFont = {};
  for (const weightKey in weights) {
    const key = weightKey as Weight;
    const fontWeight = weights[key];
    if (!fontWeight) {
      continue;
    }
    weightedFont[key] = generateFont(
      fontFamily,
      fontSize,
      lineHeight,
      fontWeight,
    );
  }
  return weightedFont;
};

// breakpoint
export type BreakpointType = 'fluid' | 'fixed';

export type BreakpointItem = {
  min: number;
  type: BreakpointType;
  columns: number;
  margin: number | 'auto';
  gutter: number;
};

export const generateBreakpoint =
  (
    min: number,
    type: BreakpointType,
    columns: number,
    margin: number | 'auto',
    gutter: number,
  ) =>
  (serializedStyles: any) => css`
    @media (min-width: ${min}px) {
      ${serializedStyles}
    }
  `;
